function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["_uniqueIdFn"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import reactHoc from 'react-hoc';
import uniqueId from 'lodash.uniqueid';
/**
 * @class StableUniqueId
 */

var StableUniqueId = /*#__PURE__*/function (_React$Component) {
  _inherits(StableUniqueId, _React$Component);

  var _super = _createSuper(StableUniqueId);

  function StableUniqueId() {
    _classCallCheck(this, StableUniqueId);

    return _super.apply(this, arguments);
  }

  _createClass(StableUniqueId, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var uniqueIdFn = this.props.uniqueIdFn;
      this.setState({
        uniqueId: uniqueIdFn()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          render = _this$props.render,
          prefix = _this$props.prefix;
      var uniqueId = this.state.uniqueId;
      return render({
        uniqueId: "".concat(prefix || '').concat(uniqueId)
      });
    }
  }]);

  return StableUniqueId;
}(React.Component);

StableUniqueId.propTypes = {
  /**
   * ({ uniqueId: string }) => JSX
   */
  render: PropTypes.func.isRequired,

  /**
   * Optionally applies a prefix to the generated ID.
   */
  prefix: PropTypes.string,

  /**
   * () => string
   * Provide a custom function to generate the unique ID. Useful for testing.
   * Defaults to lodash's `uniqueId` function.
   *
   * NOTE: will only be called once, when the function is mounted. Updating this function will not change the uniqueId.
   */
  uniqueIdFn: PropTypes.func
};
StableUniqueId.defaultProps = {
  uniqueIdFn: uniqueId
};
export default StableUniqueId;
export { StableUniqueId };
/**
 * @param {object} opts
 * @param {string} opts.prefix
 * @param {string} opts.name The name of the string prop that will be passed to the component
 */

export var withStableUniqueId = function withStableUniqueId() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      prefix = _ref.prefix,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'uniqueId' : _ref$name,
      uniqueIdFn = _ref.uniqueIdFn;

  return reactHoc( // eslint-disable-next-line react/display-name
  function (Component) {
    return function (_ref2) {
      var _uniqueIdFn = _ref2._uniqueIdFn,
          props = _objectWithoutProperties(_ref2, _excluded);

      return /*#__PURE__*/React.createElement(StableUniqueId, {
        prefix: prefix,
        render: function render(_ref3) {
          var uniqueId = _ref3.uniqueId;

          var childProps = _objectSpread(_defineProperty({}, name, uniqueId), props);

          if (_uniqueIdFn) {
            childProps._uniqueIdFn = _uniqueIdFn;
          }

          return /*#__PURE__*/React.createElement(Component, childProps);
        },
        uniqueIdFn: _uniqueIdFn || uniqueIdFn
      });
    };
  }, 'withStableUniqueId');
};
export var useStableUniqueId = function useStableUniqueId(prefix) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref4$uniqueIdFn = _ref4.uniqueIdFn,
      uniqueIdFn = _ref4$uniqueIdFn === void 0 ? uniqueId : _ref4$uniqueIdFn;

  return function () {
    var _React$useState = React.useState(function () {
      return uniqueIdFn();
    }),
        _React$useState2 = _slicedToArray(_React$useState, 1),
        uniqueId = _React$useState2[0];

    return "".concat(prefix || '').concat(uniqueId);
  }();
};